import { Component } from '@angular/core';
import { Params, Router } from '@angular/router';


@Component({
  selector: 'app-server-error',
  templateUrl: './server-error.component.html',
  styleUrls: ['./server-error.component.css']
})
export class ServerErrorComponent {
  constructor(private router: Router) { }

  private _queryParams: Params;
  get queryParams(): Params {
    if (this._queryParams == null) {
      var urlTree = this.router.parseUrl(this.router.url);
      this._queryParams = urlTree.queryParams;
    }
    return this._queryParams;
  }

  get timestamp(): string {
    return this.queryParams?.timestamp;
  }

  get status(): string {
    return this.queryParams?.status;
  }

  get error(): string {
    return this.queryParams?.error;
  }

  get message(): string {
    return this.queryParams?.friendlyMessage || this.queryParams?.message;
  }

  get path(): string {
    return this.queryParams?.path;
  }

}
